import http from 'api/httpClient';


export type FetchPnlYearsResponse = {
  years: string[];
};

export async function fetchPnlYears(): Promise<FetchPnlYearsResponse> {
  return http.get('/api/v1/pnl/years');
}

export type PnlLevelOption = {
  ou_code: string;
  ou_name: string;
};

export type PnlLevel = {
  id: number | string;
  name: string;
  visible?: boolean;
  selected?: string[] | null;
  options?: PnlLevelOption[];
};

export type UpdateDropdownsRequest = {
  year: string;
  selection: Record<string, string[]>;
};

export type UpdateDropdownsResponse = {
  levels: PnlLevel[];
};

export async function updatePnlDropdowns(payload: UpdateDropdownsRequest): Promise<UpdateDropdownsResponse> {
  return http.post('/api/v1/pnl/update-dropdowns', payload);
}

export type PnlTableRow = {
  MIS_Description: string;
  Total: number;
  Average: number;
  Apr: number;
  May: number;
  Jun: number;
  Jul: number;
  Aug: number;
  Sep: number;
  Oct: number;
  Nov: number;
  Dec: number;
  Jan: number;
  Feb: number;
  Mar: number;
};

export type FetchPnlDataRequest = {
  year: string;
  filters: Record<string, string[]>;
};

export type FetchPnlDataResponse = {
  rows: PnlTableRow[];
};

export async function fetchPnlData(payload: FetchPnlDataRequest): Promise<FetchPnlDataResponse> {
  return http.post('/api/v1/pnl/fetch-data', payload);
}

export type CustomerDataRow = {
  row_kind: 'header' | 'metric';
  customer_code: string;
  customer_name: string;
  metric: string | null;
  Total: number;
  Average: number;
  Apr: number;
  May: number;
  Jun: number;
  Jul: number;
  Aug: number;
  Sep: number;
  Oct: number;
  Nov: number;
  Dec: number;
  Jan: number;
  Feb: number;
  Mar: number;
};

export type FetchCustomerDataRequest = {
  year: string;
  ou_codes: string[];
};

export type FetchCustomerDataResponse = {
  rows: CustomerDataRow[];
};

export async function fetchCustomerData(payload: FetchCustomerDataRequest): Promise<FetchCustomerDataResponse> {
  return http.post('/api/v1/pnl/customer-data', payload);
}
